"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var lq_exports = {};
__export(lq_exports, {
  LiveQueries: () => LiveQueries
});
module.exports = __toCommonJS(lq_exports);
var import_fast_equals = require("fast-equals");
var import_query = require("./messages/query");
var import_query2 = require("./notifications/query");
var import_query3 = require("./notification-contexts/query");
var import_query4 = require("./label/query");
var import_query5 = require("./collaborators/query");
const maxQueriesCache = 100;
class LiveQueries {
  constructor(client, hulylake) {
    this.client = client;
    this.hulylake = hulylake;
    this.client.onEvent = (event) => {
      this.eventQueue = this.eventQueue.then(() => this.onEvent(event)).catch((err) => {
        console.error("Error handling event:", err);
      });
    };
    this.client.onRequest = (event, promise) => {
      void this.onRequest(event, promise);
    };
  }
  static {
    __name(this, "LiveQueries");
  }
  queries = /* @__PURE__ */ new Map();
  unsubscribed = /* @__PURE__ */ new Map();
  counter = 0;
  eventQueue = Promise.resolve();
  async onEvent(event) {
    await Promise.all(Array.from(this.queries.values()).map((q) => q.onEvent(event)));
  }
  async onRequest(event, promise) {
    for (const q of this.queries.values()) {
      void q.onRequest(event, promise);
    }
  }
  queryMessages(params, callback, options) {
    return this.createAndStoreQuery(
      params,
      callback,
      options,
      import_query.MessagesQuery,
      (params2) => this.findMessagesQuery(params2, options)
    );
  }
  queryNotifications(params, callback) {
    return this.createAndStoreQuery(
      params,
      callback,
      void 0,
      import_query2.NotificationQuery,
      (params2) => this.findNotificationQuery(params2)
    );
  }
  queryNotificationContexts(params, callback, options) {
    return this.createAndStoreQuery(
      params,
      callback,
      options,
      import_query3.NotificationContextsQuery,
      (params2) => this.findNotificationContextsQuery(params2)
    );
  }
  queryLabels(params, callback) {
    return this.createAndStoreQuery(
      params,
      callback,
      void 0,
      import_query4.LabelsQuery,
      (params2) => this.findLabelsQuery(params2)
    );
  }
  queryCollaborators(params, callback) {
    return this.createAndStoreQuery(
      params,
      callback,
      void 0,
      import_query5.CollaboratorsQuery,
      (params2) => this.findCollaboratorsQuery(params2)
    );
  }
  createAndStoreQuery(params, callback, options, QueryClass, finder) {
    const query = this.findOrCreateQuery(params, callback, options, QueryClass, finder);
    this.queries.set(query.id, query);
    return {
      unsubscribe: /* @__PURE__ */ __name((force) => {
        this.unsubscribeQuery(query, force);
      }, "unsubscribe")
    };
  }
  findOrCreateQuery(params, callback, options, QueryClass, finder) {
    const id = ++this.counter;
    const exists = finder(params);
    if (exists !== void 0) {
      if (this.unsubscribed.has(exists.id)) {
        this.unsubscribed.delete(exists.id);
        exists.setCallback(callback);
        return exists;
      } else {
        const result = exists.copyResult();
        return new QueryClass(this.client, this.hulylake, id, params, options, callback, result);
      }
    }
    return new QueryClass(this.client, this.hulylake, id, params, options, callback, void 0);
  }
  findQuery(params, QueryClass, options) {
    for (const query of this.queries.values()) {
      if (query instanceof QueryClass && this.compareParams(params, query.params) && this.compareOptions(options, query.options)) {
        return query;
      }
    }
  }
  findMessagesQuery(params, options) {
    return this.findQuery(params, import_query.MessagesQuery, options);
  }
  findNotificationQuery(params) {
    return this.findQuery(params, import_query2.NotificationQuery);
  }
  findNotificationContextsQuery(params) {
    return this.findQuery(params, import_query3.NotificationContextsQuery);
  }
  findLabelsQuery(params) {
    return this.findQuery(params, import_query4.LabelsQuery);
  }
  findCollaboratorsQuery(params) {
    return this.findQuery(params, import_query5.CollaboratorsQuery);
  }
  compareParams(q1, q2) {
    return Object.keys(q1).length === Object.keys(q2).length && (0, import_fast_equals.deepEqual)(q1, q2);
  }
  compareOptions(q1, q2) {
    return Object.keys(q1 ?? {}).length === Object.keys(q2 ?? {}).length && (0, import_fast_equals.deepEqual)(q1, q2);
  }
  removeOldQueries() {
    const unsubscribed = Array.from(this.unsubscribed).sort((a, b) => a[1] - b[1]);
    for (let i = 0; i < this.unsubscribed.size / 2; i++) {
      const u = unsubscribed.shift();
      if (u === void 0) return;
      this.unsubscribe(u[0]);
    }
  }
  unsubscribe(id) {
    const query = this.queries.get(id);
    if (query == null) return;
    void query.unsubscribe();
    this.queries.delete(id);
    this.unsubscribed.delete(id);
  }
  unsubscribeQuery(query, force = false) {
    this.unsubscribed.set(query.id, Date.now());
    query.removeCallback();
    if (this.unsubscribed.size > maxQueriesCache) {
      this.removeOldQueries();
    }
    if (force) {
      this.unsubscribe(query.id);
    }
  }
  close() {
    this.queries.clear();
    this.unsubscribed.clear();
  }
  async refresh() {
    for (const [id, query] of this.queries.entries()) {
      if (this.unsubscribed.has(id)) {
        this.unsubscribe(id);
        continue;
      }
      try {
        await query.refresh();
      } catch (e) {
        console.error("Failed to refresh live query", e, query.id, query.params);
      }
    }
  }
}
//# sourceMappingURL=lq.js.map
